import { ClickingConfig } from './types'

const plusMinusConfig: { [key: string]: ClickingConfig } = {
  '1': {
    minNumerator: 1,
    maxNumerator: 4,
    minDenominator: 2,
    maxDenominator: 5,
    resetHistory: 2,
  },
  '2': {
    minNumerator: 0,
    maxNumerator: 6,
    minDenominator: 4,
    maxDenominator: 7,
    resetHistory: 2,
  },
  '3': {
    minNumerator: 0,
    maxNumerator: 9,
    minDenominator: 7,
    maxDenominator: 10,
    resetHistory: 2,
  },
}
/**
 *
 * @param difficultyLevel
 * @returns configuration object based on difficulty level
 */
export function getRangesByDifficulty(difficultyLevel: number): ClickingConfig {
  return plusMinusConfig[difficultyLevel] || plusMinusConfig[1]
}
